// Mock templates data - matching studio version for apple-to-apple comparison
// This replaces the API call temporarily

import { TemplatesResponse, TemplateSummary, Channel } from 'types/cx-editor';

const mockTemplates: TemplateSummary[] = [
  // Email templates
  { templateKey: 'EMAIL.SF.MONTHLY_SUMMARY', name: '(EL) Monthly Summary', channel: 'Email' },
  { templateKey: 'EMAIL.SF.BILL_PROJECTION', name: '(EL) Bill Projection', channel: 'Email' },
  { templateKey: 'EMAIL.SF.BUDGET_ALERT', name: '(EL) Budget Alert', channel: 'Email' },
  { templateKey: 'EMAIL.SF.NEIGHBOURHOOD_COMPARISON', name: '(EL) Neighbourhood Comparison', channel: 'Email' },
  { templateKey: 'EMAIL.SF.EV_MONTHLY_TRACKER', name: '(EL) EV Monthly Tracker', channel: 'Email' },
  
  // HER templates
  { templateKey: 'HER', name: '(EL) Home Energy Report', channel: 'HER' },
  
  // SMS templates
  { templateKey: 'SMS.SF.HIGH_BILL_ALERT', name: '(EL) High Bill Alert SMS', channel: 'SMS' },
  
  // Web templates
  { templateKey: 'DASHBOARD.ELECTRIC', name: '(EL) Home Dashboard', channel: 'Web' },
  { templateKey: 'WEB_ENERGY_DETAILS', name: '(EL) Energy Details', channel: 'Web' },
  { templateKey: 'WEB_BILL_ANALYSIS', name: '(EL) Bill Analysis', channel: 'Web' },
  { templateKey: 'WEB_MONTHLY_SUMMARY', name: '(EL) Monthly Summary', channel: 'Web' },
  { templateKey: 'WEB_SIMILAR_HOMES', name: '(EL) Similar Homes', channel: 'Web' },
  { templateKey: 'WEB_MY_RECOS', name: '(EL) My Recommendations', channel: 'Web' },
  { templateKey: 'WEB_HOME_SURVEY', name: '(EL) Home Survey', channel: 'Web' },
  { templateKey: 'WEB_PREFERENCES', name: '(EL) User Preferences', channel: 'Web' },
  { templateKey: 'WEB_DOWNLOAD_MY_USAGE', name: '(EL) Download My Usage', channel: 'Web' },
  { templateKey: 'WEB_MY_NOTIFICATIONS', name: '(EL) My Notifications', channel: 'Web' },
];

export const MOCK_TEMPLATES_RESPONSE: TemplatesResponse = {
  channels: [
    {
      name: 'Email' as Channel,
      templates: mockTemplates.filter(t => t.channel === 'Email'),
    },
    {
      name: 'HER' as Channel,
      templates: mockTemplates.filter(t => t.channel === 'HER'),
    },
    {
      name: 'SMS' as Channel,
      templates: mockTemplates.filter(t => t.channel === 'SMS'),
    },
    {
      name: 'Web' as Channel,
      templates: mockTemplates.filter(t => t.channel === 'Web'),
    },
  ],
};

